module.exports = __webpack_public_path__ + "static/media/logo_qualdo-mqx.00c85e2b.svg";